import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import zhCN from "ant-design-vue/es/locale/zh_CN";

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const globalSize = ref("middle");

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, {
    locale: _unref(zhCN),
    size: globalSize.value,
    theme: {
      token: {
        colorPrimary: '#fccf00', // 全局主色

      },
      // 单独定制某类组件的样式
      components: {
        Button: {
          // colorPrimary: '#00885a', // 按钮主色单独覆盖
        },
        Input: {
          // borderRadius: 2, // 输入框圆角单独覆盖
        },
      },
    }
  }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }, 8, ["locale", "size"]))
}
}

})